// main.ts
import * as Sentry from "@sentry/vue";
import "./assets/main.css";
import "tailwindcss/tailwind.css";
import "flowbite";
import "flowbite-vue";

import {createApp, ref} from "vue";
import apiPlugin from "@/plugins/apiPlugin";

import {createPinia} from "pinia";
import piniaPluginPersistedState from "pinia-plugin-persistedstate";
import App from "./App.vue";
import Notifications from "notiwind";
import {Auth0Plugin, createAuth0} from "@auth0/auth0-vue";


import router from "./router";


const app = createApp(App);

if (import.meta.env.PROD) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

const pinia = createPinia();
pinia.use(piniaPluginPersistedState);

app.use(pinia);
console.log(import.meta.env.VITE_AUTH0_AUDIENCE);

const auth0 =
    createAuth0({
        // použití env proměnných z .env
        domain: import.meta.env.VITE_AUTH0_DOMAIN,
        clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
        authorizationParams: {
            redirect_uri: import.meta.env.VITE_AUTH0_REDIRECT_URI,
            audience: import.meta.env.VITE_AUTH0_AUDIENCE,
        },
        useRefreshTokens: true,
        cacheLocation: 'localstorage',
    });

app.use(auth0);
app.use(apiPlugin);

app.use(Notifications);
app.use(router);


app.mount("#app");

export default app;
